<template>
  <section
    class="m-modal"
    :class="[staticClass, className]"
  >
    <overlay
      v-if="overlay"
      class="m-modal__overlay"
      :transition="transitionOverlay"
      :visible="visible"
      @click="checkPersistence"
    />
    <transition :name="transitionModal">
      <div
        v-if="visible"
        class="m-modal__container"
        :class="{'-large': largeModal}"
      >
        <div class="m-modal__center h-100">
          <button
            v-if="cross"
            class="m-modal__close p-3"
            :aria-label="ariaLabelClose"
            @click="close"
          >
            <!--@slot Use this slot to place content inside the close button.-->
            <slot name="close">
              <base-icon icon="close" />
            </slot>
          </button>
          <div
            ref="content"
            class="m-modal__content h-100 w-100 bg-transparent"
          >
            <!--@slot Use this slot to place content inside the modal.-->
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>
<script>
import BaseIcon from '@/components/atoms/BaseIcon';
import Overlay from '@/components/atoms/Overlay';

export default {
  name: 'Modal',
  components: {
    BaseIcon,
    Overlay
  },
  model: {
    prop: 'visible',
    event: 'close'
  },
  props: {
    /**
     * Visibility of the modal
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * Cross closing modal button
     */
    cross: {
      type: Boolean,
      default: true
    },
    /**
     * Whether to show the overlay
     */
    overlay: {
      type: Boolean,
      default: true
    },
    /**
     * If true clicking outside will not dismiss the modal
     */
    persistent: {
      type: Boolean,
      default: false
    },
    /**
     * overlay transition effect
     */
    transitionOverlay: {
      type: String,
      default: 'fade'
    },
    /**
     * overlay transition effect
     */
    transitionModal: {
      type: String,
      default: 'fade'
    },
    /**
     * aria-label of the close button
     */
    ariaLabelClose: {
      type: String,
      default: null
    },
    /**
     * class for a large modal
     */
     largeModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      staticClass: null,
      className: null
    };
  },
  watch: {
    visible: {
      handler: function (value) {
        if (typeof window === 'undefined' || typeof document === 'undefined')
          return;
        if (value) {
          this.$nextTick(() => {
            this.$disableBodyScroll(this.$refs.content);
          });
          document.addEventListener('keydown', this.keydownHandler);
        } else {
          this.$clearAllBodyScrollLocks();
          document.removeEventListener('keydown', this.keydownHandler);
        }
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('close', false);
    },
    checkPersistence () {
      if (!this.persistent) {
        this.close();
      }
    },
    keydownHandler (e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.close();
      }
    },
    classHandler () {
      if (this.staticClass !== this.$vnode.data.staticClass) {
        this.staticClass = this.$vnode.data.staticClass;
      }
      if (this.className !== this.$vnode.data.class) {
        this.className = this.$vnode.data.class;
      }
    }
  }
};
</script>
